import { Coordinate } from "PosterEditor/hooks/use-coordinates";
import { StyledPoint, MapLabel, StaticLabel, Backdrop } from "./poster-project";

export interface Point {
  x: number;
  y: number;
}

export interface Size {
  width: number;
  height: number;
}

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface PointCoordinate {
  point: Point;
  coordinate: Coordinate;
}

export interface PointStyle {
  showPoint: boolean;
  size: number;
  mainColor: string;
  secondaryColor?: string | undefined;
  icon?: PointIconName;
  imageName?: string | undefined;
  //Populated on fetching signed URL.
  imageURL?: string | undefined;
}

export type PointIconName =
  | "DOT"
  | "PIN_ONE"
  | "PIN_TWO"
  | "MAN_WALKING"
  | "RAIN_CLOUD"
  | "THUNDER_CLOUD"
  | "SNOW_CLOUD"
  | "WIND"
  | "TEMPERATURE_UP"
  | "TEMPERATURE_DOWN"
  | "SUN"
  | "FACE_1"
  | "FACE_2"
  | "FACE_3"
  | "FACE_4"
  | "FACE_5"
  | "FACE_6"
  | "FACE_7"
  | "SKULL"
  | "WINE"
  | "PINT"
  | "HOME";

export type LinePattern =
  | "singleSolid"
  | "doubleSolid"
  | "doubleTranslucent"
  | "dotDash";
export interface LineStyle {
  width: number;
  mainPattern: LinePattern;
  mainColor: string;
  flankPattern?: LinePattern;
  flankColor?: string;
  dotDash: boolean;
  shadow: Shadow | undefined;
}

export interface Shadow {
  color: string;
  opacity: number;
  blur: number;
  offset: Size;
  isHidden: boolean;
}

export type LabelSideHorizontal = "left" | "right" | "center";
export type LabelSideVertical = "top" | "bottom" | "center";

export interface LabelPointerSide {
  horizontal: LabelSideHorizontal;
  vertical: LabelSideVertical;
}

export type LabelDecoration =
  | "none"
  | "border"
  | "line"
  | "bracket"
  | "dot"
  | "corner";

export const allowCornerPointerForDecoration = (
  decoration: LabelDecoration
) => {
  switch (decoration) {
    case "bracket":
    case "line":
    case "dot":
      return false;
    default:
      return true;
  }
};

export const allowSidePointerForDecoration = (decoration: LabelDecoration) => {
  switch (decoration) {
    case "corner":
      return false;
    default:
      return true;
  }
};

export type ElementType =
  | "line"
  | "point"
  | "mapLabel"
  | "staticLabel"
  | "backdrop";
//Used primarily to help pass items around for editing.
export interface Element {
  type: ElementType;
  id?: string;
  mapLabel?: MapLabel;
  staticLabel?: StaticLabel;
  styledPoint?: StyledPoint;
  backdrop?: Backdrop;
  point?: Point;
}

export interface GPXFile {
  filename: String;
  signedURL: String;
}
